import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./about-skeleton.css";

const AboutSkeleton = () => {
  const skeletonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0.5 },
    visible: { opacity: 1 },
  };

  return (
    <motion.section
      className="about section"
      id="about"
      initial="hidden"
      animate="visible"
      variants={skeletonVariants}
    >
      {/* Title and Subtitle */}
      <motion.h2
        className="section__title skeleton-title-large"
        variants={itemVariants}
      />
      <motion.span
        className="section__subtitle skeleton-subtitle"
        variants={itemVariants}
      />

      {/* Container */}
      <motion.div className="about__container container grid">
        {/* Image Skeleton */}
        <motion.div variants={itemVariants} className="skeleton-about-image" />

        {/* Data Section */}
        <motion.div className="about__data">
          {/* Info Cards Skeleton */}
          <div className="about__info grid skeleton-info-grid">
            {[1, 2, 3].map((_, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="skeleton-about-box"
              >
                <motion.div variants={itemVariants} className="skeleton-icon" />
                <motion.div
                  variants={itemVariants}
                  className="skeleton-box-title"
                />
                <motion.div
                  variants={itemVariants}
                  className="skeleton-box-subtitle"
                />
              </motion.div>
            ))}
          </div>

          {/* Description Lines */}
          <div className="skeleton-description-container">
            <motion.div variants={itemVariants} className="skeleton-line" />
            <motion.div variants={itemVariants} className="skeleton-line" />
            <motion.div
              variants={itemVariants}
              className="skeleton-line short"
            />
          </div>

          {/* Button Skeleton */}
          <motion.div
            variants={itemVariants}
            className="skeleton-button-large"
          />
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default AboutSkeleton;
